import { StyleSheet } from "react-native";

export const globalStyles = StyleSheet.create({
    disabled: {
     opacity: 0.6,
        pointerEvents:"none"
    },

});
